module.exports = __webpack_public_path__ + "img/ico-adubo-w.3c180b08.png";